"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Photo16 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M9.696 2c.819 0 1.183.128 1.508.726l.213.424c.221.425.354.579.496.603l.044.004h1.13c1.074 0 1.837.737 1.908 1.802L15 5.72v6.148c0 1.096-.712 1.886-1.754 1.959l-.159.005H2.913c-1.074 0-1.837-.737-1.908-1.802L1 11.87V5.721c0-1.096.712-1.886 1.754-1.959l.159-.005h1.13c.175 0 .321-.166.606-.737l.075-.152c.326-.676.658-.847 1.422-.866L9.696 2zm.123 1H6.18c-.33.002-.402.016-.487.165l-.07.138c-.48.996-.787 1.402-1.444 1.45l-.137.004h-1.13c-.527 0-.863.308-.908.838L2 5.72v6.148c0 .563.298.912.795.959l.118.005h10.174c.527 0 .863-.308.908-.838L14 11.87V5.721c0-.563-.298-.912-.795-.959l-.118-.005h-1.13c-.707 0-1.027-.344-1.485-1.257l-.16-.325c-.087-.158-.155-.173-.493-.175zM8 4.917a3.5 3.5 0 11-.001 7 3.5 3.5 0 01.001-7zm0 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm0 .5a2 2 0 110 4 2 2 0 010-4zm0 1a1 1 0 100 2 1 1 0 000-2zm4-2a.5.5 0 110 1 .5.5 0 010-1z", className: "photo-16_svg__path-1" }))); };
var StyledPhoto16 = styled_components_1.default(Photo16)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledPhoto16;
var templateObject_1;
//# sourceMappingURL=Photo16.js.map